module.exports = __webpack_public_path__ + "static/media/apartment20.0df50c0e.jpg";